var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F37D53"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3892_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 15C20.3851 15 15 20.3851 15 27C15 33.6149 20.3851 39 27 39C33.6149 39 39 33.6149 39 27C39 20.3851 33.6149 15 27 15ZM27 36.5157C21.7537 36.5157 17.4843 32.2463 17.4843 27C17.4843 21.7537 21.7537 17.4843 27 17.4843C32.2463 17.4843 36.5157 21.7537 36.5157 27C36.5157 32.2463 32.2463 36.5157 27 36.5157Z",
    fill: "#F37D53",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0479 26.3252C28.4677 26.0029 27.8529 25.7648 27.2429 25.5119C26.8909 25.3681 26.5537 25.1946 26.2562 24.9566C25.671 24.4855 25.7801 23.7268 26.4694 23.4243C26.6628 23.34 26.8661 23.3103 27.0744 23.3004C27.8727 23.2558 28.6264 23.4045 29.3504 23.7516C29.7074 23.9252 29.8264 23.8706 29.9504 23.4987C30.0793 23.102 30.1884 22.7004 30.3025 22.3037C30.3818 22.0359 30.2826 21.8574 30.0297 21.7483C29.5686 21.545 29.0925 21.3962 28.5917 21.3219C27.9421 21.2177 27.9421 21.2177 27.9372 20.5632C27.9322 19.6359 27.9322 19.6359 27.0099 19.6409C26.876 19.6409 26.7421 19.6359 26.6082 19.6409C26.1768 19.6558 26.1025 19.7301 26.0925 20.1615C26.0876 20.3549 26.0925 20.5533 26.0925 20.7467C26.0876 21.3268 26.0876 21.3169 25.5322 21.5153C24.1934 22.0012 23.3653 22.9136 23.276 24.3764C23.1967 25.6706 23.871 26.5434 24.9322 27.1781C25.5867 27.5698 26.3107 27.8029 27.0049 28.1103C27.2777 28.2293 27.5355 28.3681 27.7586 28.5566C28.4281 29.107 28.3041 30.0243 27.5107 30.3715C27.0843 30.5549 26.638 30.6045 26.1818 30.545C25.4727 30.4558 24.7934 30.2723 24.1586 29.94C23.7867 29.7467 23.6777 29.7962 23.5487 30.2029C23.4396 30.5549 23.3405 30.907 23.2463 31.2591C23.1173 31.7351 23.162 31.8491 23.6182 32.0673C24.1934 32.345 24.8132 32.4888 25.4429 32.5929C25.9339 32.6723 25.9537 32.6921 25.9586 33.2029C25.9586 33.4359 25.9636 33.669 25.9636 33.8971C25.9686 34.1896 26.1074 34.3582 26.4099 34.3632C26.752 34.3681 27.0942 34.3681 27.4363 34.3632C27.714 34.3582 27.8578 34.2045 27.8628 33.9219C27.8628 33.6045 27.8777 33.2872 27.8677 32.9698C27.8529 32.6475 27.9917 32.4839 28.3041 32.3996C29.0182 32.2062 29.6281 31.8194 30.0991 31.2491C31.3884 29.6624 30.8925 27.3467 29.0479 26.3252Z",
    fill: "#F37D53",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3892_468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/Budget.58b5bbb1e2edd29a80940e0264dbe942.svg";
export { ForwardRef as ReactComponent };